import type { QuikQStation } from '../services/quikqApi';

/**
 * Group stations that are the same physical location: prefer address+city+state+zip;
 * if that is incomplete, fall back to rounded coordinates (or stationCode).
 */
export function stationDedupeKey(s: QuikQStation): string {
  const stationCode = String(s.stationCode || '').trim().toLowerCase();
  if (stationCode) {
    return `code:${stationCode}`;
  }

  const street = String(s.address || '').trim().toLowerCase();
  const city = String(s.city || '').trim().toLowerCase();
  const state = String(s.state || '').trim().toLowerCase();
  const zip = String(s.zip || '').trim().toLowerCase();
  if ((street && city) || (street && state) || (city && state)) {
    return `addr:${street}|${city}|${state}|${zip}`;
  }
  const lat = Number(s.latitude);
  const lng = Number(s.longitude);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    return `id:${String(s.stationCode || '')}`;
  }
  return `coord:${lat.toFixed(5)},${lng.toFixed(5)}`;
}

export function dedupeStationsByKey(
  stations: QuikQStation[],
  score: (s: QuikQStation) => number
): QuikQStation[] {
  const map = new Map<string, QuikQStation>();
  for (const s of stations) {
    const key = stationDedupeKey(s);
    const existing = map.get(key);
    if (!existing) {
      map.set(key, s);
      continue;
    }
    if (score(s) > score(existing)) {
      map.set(key, s);
    }
  }
  return Array.from(map.values());
}
